var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',{staticClass:"text-sm font-medium text-gray-600 leading-4 mb-4"},[_vm._v("Assigned To")]),(!_vm.loading)?_c('AssignForm',{attrs:{"contact-request":_vm.contactRequest}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }